var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readyToRender)?_c('div',[_c('filter-bar',{attrs:{"addition_state":_vm.lead_state},on:{"add-new-lead":function($event){_vm.add_lead_state = true},"cancel-add-new-lead":function($event){_vm.add_lead_state = false}}}),_vm._v(" "),(_vm.add_lead_state)?_c('add-lead',{on:{"close":function($event){_vm.add_lead_state = false}}}):_vm._e(),_vm._v(" "),(!_vm.add_lead_state)?_c('results'):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bffaf53","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/CRM/Crm.vue
// module id = 1826
// module chunks = 0